module.exports = __webpack_public_path__ + "img/360.44fc6e21.svg";